// ===============================
// EcommerceFooter.jsx
// ===============================

import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const EcommerceFooter = () => {
  return (
    <footer className="footer">

      {/* NEWSLETTER */}
      <div className="newsletter">
        <div className="container newsletter-wrapper">

          <div className="newsletter-text">
            <h2>Subscribe Our Newsletter</h2>
            <p>
              Get latest updates on new products and offers.
            </p>
          </div>

          <div className="newsletter-form">
            <input
              type="email"
              placeholder="Enter your email"
            />

            <button>
              <i className="fa-solid fa-paper-plane"></i>
            </button>
          </div>

        </div>
      </div>

      {/* MAIN FOOTER */}
      <div className="footer-main">
        <div className="container footer-grid">

          {/* BRAND */}
          <div className="footer-column">
            <h2 className="footer-logo">
              <span>Sab</span> Milega
            </h2>

            <p>
              Your one-stop shop for trendy products,
              home essentials, beauty, gadgets & more.
            </p>

            <div className="social-icons">

              <a href="/">
                <i className="fa-brands fa-facebook-f"></i>
              </a>

              <a href="/">
                <i className="fa-brands fa-instagram"></i>
              </a>

              <a href="/">
                <i className="fa-brands fa-x-twitter"></i>
              </a>

              <a href="/">
                <i className="fa-brands fa-youtube"></i>
              </a>

            </div>
          </div>

          {/* SHOP */}
          <div className="footer-column">
            <h3>Shop</h3>

            <Link to="/shop">All Products</Link>
            <Link to="/new-arrivals">New Arrivals</Link>
            <Link to="/deals">Best Deals</Link>
            <Link to="/trending">Trending</Link>
          </div>

          {/* CUSTOMER SERVICE */}
          <div className="footer-column">
            <h3>Customer Service</h3>

            <Link to="/">Track Order</Link>
            <Link to="/">Returns & Refunds</Link>
            <Link to="/">Shipping Policy</Link>
            <Link to="/">FAQ</Link>
          </div>

          {/* COMPANY */}
          <div className="footer-column">
            <h3>Company</h3>

            <Link to="/">About Us</Link>
            <Link to="/contact">Contact Us</Link>
            <Link to="/">Privacy Policy</Link>
            <Link to="/">Terms & Conditions</Link>
          </div>

          {/* PAYMENT */}
          <div className="footer-column">
            <h3>We Accept</h3>

            <div className="payment-box">
              <span>VISA</span>
              <span>MasterCard</span>
              <span>UPI</span>
              <span>PayPal</span>
            </div>
          </div>

        </div>
      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <div className="container footer-bottom-content">

          <p>
            © 2026 Sab Milega. All Rights Reserved.
          </p>

          <div className="footer-bottom-links">
            <Link to="/">Privacy</Link>
            <Link to="/">Terms</Link>
          </div>

        </div>
      </div>

    </footer>
  );
};

export default EcommerceFooter;